var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 8) scale(0.8) translate(-8 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 8C14.6667 11.68 11.68 14.6667 8 14.6667C4.32 14.6667 2.07333 10.96 2.07333 10.96M2.07333 14.2933V10.96H5.08667M1.33333 8C1.33333 4.32 4.29333 1.33333 8 1.33333C12.4467 1.33333 14.6667 5.04 14.6667 5.04M11.7067 5.04H14.6667V1.70667",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    vectorEffect: "non-scaling-stroke"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.46807ba0060d92e959dd15aec01cf180.svg";
export { ForwardRef as ReactComponent };